import { InjectionToken } from '@angular/core';
import type { Auth } from 'firebase/auth';
import type { Firestore } from 'firebase/firestore';
import type { Functions } from 'firebase/functions';
import type { FirebaseStorage } from 'firebase/storage';

export const AUTH = new InjectionToken<Auth>('Firebase Auth');
export const FIRESTORE = new InjectionToken<Firestore>('Firestore');
export const FUNCTIONS = new InjectionToken<Functions>('Firebase Functions');
export const STORAGE = new InjectionToken<FirebaseStorage>('Firebase Storage');
